import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=6fc1591c&scoped=true"
import script from "./OverviewTab.vue?vue&type=script&lang=ts"
export * from "./OverviewTab.vue?vue&type=script&lang=ts"
import style0 from "./OverviewTab.vue?vue&type=style&index=0&id=6fc1591c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc1591c",
  null
  
)

export default component.exports